import { customBaseQuery } from '@/lib/baseQuery';
import { ApiResponse } from '@/shared/types';
import { GoogleDriveItem } from '@/shared/types/GoogleDrive';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const driveApi = createApi({
  reducerPath: 'driveApi',
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    searchFolderInFileInvite: builder.query<
      ApiResponse<GoogleDriveItem[]>,
      { name: string }
    >({
      query: ({ name }) =>
        `/v1/google-drive/drive/search-folders?name=${encodeURIComponent(name)}`,
    }),
    getFileListOfFolder: builder.query<ApiResponse<GoogleDriveItem[]>, string>({
      query: (folderId) => `/v1/google-drive/drive/files/${folderId}`,
    }),
    getMetaData: builder.query<ApiResponse<any>, string>({
      query: (fileId) => `/v1/google-drive/drive/file/${fileId}`,
    }),
    extractDataFromDriveFile: builder.query<ApiResponse<any>, string>({
      query: (fileId) => `/v1/google-drive/drive/file/data/${fileId}`,
    }),
    extractIdDataFromDriveFile: builder.query<ApiResponse<any>, string>({
      query: (fileId) => `/v1/google-drive/drive/file/id-data/${fileId}`,
    }),
    extractStatementFromDriveFile: builder.query<ApiResponse<any>, string>({
      query: (fileId) => `/v1/google-drive/drive/file/statement/${fileId}`,
    }),
    extractCreditCardStatementFromDriveFile: builder.query<
      ApiResponse<any>,
      string
    >({
      query: (fileId) =>
        `/v1/google-drive/drive/file/credit-card-statement/${fileId}`,
    }),
    extractMortgageStatementFromDriveFile: builder.query<
      ApiResponse<any>,
      string
    >({
      query: (fileId) =>
        `/v1/google-drive/drive/file/mortgage-statement/${fileId}`,
    }),
    extractPayslipFromDriveFile: builder.query<ApiResponse<any>, string>({
      query: (fileId) => `/v1/google-drive/drive/file/payslip/${fileId}`,
    }),
    extractBankStatementFromDriveFile: builder.query<ApiResponse<any>, string>({
      query: (fileId) => `/v1/google-drive/drive/file/bank-statement/${fileId}`,
    }),
    extractEmploymentContractFromDriveFile: builder.query<
      ApiResponse<any>,
      string
    >({
      query: (fileId) =>
        `/v1/google-drive/drive/file/employment-contract/${fileId}`,
    }),
    extractTenancyAgreementFromDriveFile: builder.query<
      ApiResponse<any>,
      string
    >({
      query: (fileId) =>
        `/v1/google-drive/drive/file/tenancy-agreement/${fileId}`,
    }),
    extractFTCDocumentFromDriveFile: builder.query<ApiResponse<any>, string>({
      query: (fileId) => `/v1/google-drive/drive/file/ftc/${fileId}`,
    }),
  }),
});

export const {
  useSearchFolderInFileInviteQuery,
  useGetFileListOfFolderQuery,
  useGetMetaDataQuery,
  useExtractDataFromDriveFileQuery,
  useExtractIdDataFromDriveFileQuery,
  useExtractStatementFromDriveFileQuery,
  useExtractCreditCardStatementFromDriveFileQuery,
  useExtractMortgageStatementFromDriveFileQuery,
  useExtractPayslipFromDriveFileQuery,
  useExtractBankStatementFromDriveFileQuery,
  useExtractEmploymentContractFromDriveFileQuery,
  useExtractTenancyAgreementFromDriveFileQuery,
  useExtractFTCDocumentFromDriveFileQuery,
} = driveApi;
